import { useCallback } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import {
  contentsMatchConfigAtom,
  handleDisconnectAtom,
  getMatchFiltersAtom,
} from 'src/stores/match/atoms';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { isPurchasedStarterPackageAtom } from 'src/stores/payments/atoms';
import { lastSubscriptionNudgeHasShownTimeAtom } from 'src/stores/subscription/atoms';
import { GemLackPopupModuleType } from 'src/types/gemLack';
import { ModalType } from 'src/types/Modal';

/**
 * 결제 완료 후 앱 상태를 업데이트하는 공통 핸들러.
 * - PaymentModal (인라인 모달) 에서 직접 호출
 * - useCustomWindowMessageEvent (postMessage) 에서도 호출
 */
export const usePurchaseCompleteHandler = () => {
  const contentsMatchConfig = useAtomValue(contentsMatchConfigAtom);
  const closeModal = useSetAtom(closeModalAtom);
  const handleDisconnect = useSetAtom(handleDisconnectAtom);
  const getMatchFilters = useSetAtom(getMatchFiltersAtom);
  const setIsPurchasedStarterPackage = useSetAtom(isPurchasedStarterPackageAtom);
  const setSubscriptionNudgeHasBeenShownBefore = useSetAtom(lastSubscriptionNudgeHasShownTimeAtom);

  return useCallback(
    (productModuleType?: string) => {
      // 스타터 패키지 상품 결제 완료 처리
      if (productModuleType === GemLackPopupModuleType.STARTER_PACKAGE_PRODUCT) {
        setIsPurchasedStarterPackage(true);
      }

      // 비비디 구독형 상품 결제 완료 처리
      if (
        productModuleType &&
        ['VIVIDI_ONE_TIME_PLAN', 'VIVIDI_UNLIMITED'].includes(productModuleType)
      ) {
        setSubscriptionNudgeHasBeenShownBefore(null);
        getMatchFilters();
        closeModal(ModalType.SUBSCRIPTION_POPUP);
        closeModal(ModalType.SUBSCRIPTION_PURCHASE_POPUP);
      }

      // 현재 매칭 상태가 스타터 패키지 넛징이었을 경우에 대한 결제 완료 처리 (자동으로 컨텐츠 매치 종료)
      if (contentsMatchConfig?.contentsMatchMediaInfo.mediaType === 'STARTER_PACKAGE_NUDGE') {
        closeModal(ModalType.STARTER_PACKAGE_NUDGING);
        handleDisconnect({
          reconnect: true,
          finisher: true,
        });
      }
    },
    [
      closeModal,
      contentsMatchConfig?.contentsMatchMediaInfo.mediaType,
      handleDisconnect,
      setIsPurchasedStarterPackage,
      setSubscriptionNudgeHasBeenShownBefore,
      getMatchFilters,
    ]
  );
};
